//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'upCustomClothe',
  components: {
  },
  data () {
    return {
      code:'',
      number:'',
      strip_code:'',
      name:'',
      phone:'',
      userPop:false,
      userList:[],
      selectedUser:null,
      searchLoading:false,
    }
  },
  created(){
    this.config();
  },
  mounted(){
  },
  methods:{
    clearPhone(){
      this.phone = '';
      this.userList = [];
      this.selectedUser = null;
    },
    clearName(){
      this.name = '';
    },
    searchUser(){
      let phone = (this.phone || '').trim();
      if(!/^\d{4}$|^\d{11}$/.test(phone)){
        this.$func.showToast('请输入手机号全号或后四位');
        return;
      }
      if(this.searchLoading){
        return;
      }
      this.searchLoading = true;
      this.$func.startLoading('查询中...');
      this.$api.searchFactoryUsers({phone:phone}).then((res)=>{
        this.searchLoading = false;
        this.$func.endLoading();
        if(res){
          this.userList = res.data || [];
          if(!this.userList.length){
            this.$func.showToast('未查询到用户');
            return;
          }
          this.selectedUser = this.userList[0];
          this.userPop = true;
        }
      }).catch(()=>{
        this.searchLoading = false;
        this.$func.endLoading();
      })
    },
    closeUserPop(){
      this.userPop = false;
    },
    confirmUser(){
      if(!this.selectedUser){
        this.$func.showToast('请选择用户');
        return;
      }
      this.name = this.selectedUser.name || '';
      this.phone = this.selectedUser.phone || '';
      this.closeUserPop();
    },
    sysUser(){
      let user = this.$func.getLocal('upCustomClotheUserInfo');
      if(user){
        this.name = JSON.parse(user).name;
        this.phone = JSON.parse(user).phone;
      }
    },
    getLastNumber(){
      let user = this.$func.getLocal('upCustomClotheUserInfo');
      if(!user){
        this.$func.showToast('暂无上一件衣物挂点');
        return;
      }
      let number = JSON.parse(user).number;
      if(number === undefined || number === null || number === ''){
        this.$func.showToast('上一件衣物未填写挂点');
        return;
      }
      this.number = number;
    },
    scanQRCode(key){
        let that = this;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ['qrCode','barCode'],
                success: function (res) {
                    setTimeout(()=>{
                        let result = that.$func.parseScanResult(res.resultStr);
                        if(result.indexOf(",") != -1){
                            result = result.split(',')[1];
                        }
                        if(key > 0){
                          that.strip_code = result;
                        }else{
                          that.code = result;
                        }
                    },300);
                }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    submit(){
      let that = this;
      if(!this.number && !this.strip_code){
        that.$func.showToast('挂点和灯条编码不能同时为空');
        return ;
      }
      if(!this.code){
        that.$func.showToast('输入衣物条码或扫条码');
        return ;
      }
      if(!this.phone){
        that.$func.showToast('请输入用户电话');
        return ;
      }
      this.$api.upCustomClothe({code:this.code,number:that.number,strip_code:this.strip_code,name:this.name,phone:this.phone}).then((res)=>{
        if(res){
          that.$func.setLocal('upCustomClotheUserInfo',JSON.stringify({'name':that.name,'phone':that.phone,'number':that.number}));
          that.code = '';
          that.strip_code = '';
          that.number = '';
          that.name = '';
          that.phone = '';
          that.$func.showToast('已上挂');
        } 
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/upCustomClothe.vue